import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useCart } from "../../context/Cart/context/Cart/context.js";
import { mapLineItemToDataLayerEvent } from "../../mappers/analytics/data-layer/mappers/analytics/data-layer/line-item-to-data-layer-event.js";
const getSanitizationPayloads = (actionItem) => {
  const { action, actioneeSKU, lineItemId } = actionItem;
  return {
    action,
    actioneeSKU,
    lineItemId
  };
};
const getConflictingLineItems = (sanitizationPayloads, cart) => {
  if (!cart || !sanitizationPayloads) {
    return null;
  }
  const conflictingLineItemIds = sanitizationPayloads.map((payload) => payload.lineItemId);
  return cart.lineItems.filter(
    (lineItem) => conflictingLineItemIds.find((id) => id === lineItem.id)
  );
};
const useSanitization = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [validation, setValidation] = React.useState(null);
  const [sanitizationPayloads, setSanitizationPayloads] = React.useState(
    null
  );
  const { cart } = useCart();
  const conflictingLineItems = React.useRef(null);
  const data = { sanitizationPayloads, isModalOpen, validation };
  const onSolvableValidationError = React.useCallback(
    (solvableValidationErrors) => {
      if (solvableValidationErrors.length > 0 && solvableValidationErrors[0]) {
        const actions = solvableValidationErrors.map((error) => error.actionItem.action);
        if (solvableValidationErrors.length > 1 && actions.every((val, _i, arr) => val === arr[0])) {
          const sanitizationPayloads2 = solvableValidationErrors.map(
            (error) => getSanitizationPayloads(error.actionItem)
          );
          conflictingLineItems.current = getConflictingLineItems(sanitizationPayloads2, cart);
          setValidation({
            validationError: solvableValidationErrors[0],
            singleValidation: false
          });
          setSanitizationPayloads(sanitizationPayloads2);
        } else {
          const sanitizationPayloads2 = [
            getSanitizationPayloads(solvableValidationErrors[0].actionItem)
          ];
          conflictingLineItems.current = getConflictingLineItems(sanitizationPayloads2, cart);
          setValidation({
            validationError: solvableValidationErrors[0],
            singleValidation: true
          });
          setSanitizationPayloads(sanitizationPayloads2);
        }
        setIsModalOpen(true);
      }
    },
    [cart]
  );
  const pushRemoveLineItemDataLayerEvent = React.useCallback(() => {
    const lineItems = conflictingLineItems.current;
    if (!lineItems) {
      return;
    }
    const removeFromCartEvent = mapLineItemToDataLayerEvent(
      DataLayer.DataLayerTypes.EventType.remove,
      lineItems,
      cart?.id || ""
    );
    removeFromCartEvent && DataLayer.pushEcommerceEvent(removeFromCartEvent);
  }, [cart?.id]);
  const reset = React.useCallback(() => {
    setIsModalOpen(false);
    setValidation(null);
    setSanitizationPayloads(null);
    conflictingLineItems.current = null;
  }, [setIsModalOpen, setValidation, setSanitizationPayloads]);
  return [
    data,
    {
      onSolvableValidationError,
      pushRemoveLineItemDataLayerEvent,
      reset
    }
  ];
};
export {
  useSanitization
};
//# sourceMappingURL=use-sanitization.js.map
